/** Common ISO codes for travel businesses; extend as needed. */
export const LEDGER_CURRENCY_OPTIONS = [
  "GBP",
  "EUR",
  "USD",
  "AUD",
  "CAD",
  "NZD",
  "AED",
  "CHF",
  "JPY",
  "ZAR",
] as const;

export type LedgerCurrencyOption = (typeof LEDGER_CURRENCY_OPTIONS)[number];

